const ICON_PATHS = {
  // a metronome with its weight and swinging arm
  helpers: (
    <>
      <path d="M8.2 3.5h7.6l3 17h-13.6l3-17z" fill="currentColor" fillOpacity="0.16" />
      <path d="M12 17.5 16.2 7.2" />
      <circle cx="15.4" cy="9.2" r="1.5" fill="currentColor" />
      <path d="M9 20.5v-3h6v3" />
    </>
  ),
  // a cut gem with a highlight
  gem: (
    <>
      <path d="M6.5 3.5h11l4 5.5-9.5 12L2.5 9l4-5.5z" fill="currentColor" fillOpacity="0.16" />
      <path d="M2.5 9h19" />
      <path d="M8.8 9 12 20.5 15.2 9 12 3.5 8.8 9z" />
      <path d="M5.2 5.8 6.5 7.5" strokeWidth="1.4" />
    </>
  ),
  // a paint palette
  cosmetics: (
    <>
      <path
        d="M12 3a9 9 0 1 0 0 18c1.3 0 2-.9 2-1.9 0-1.5-1.4-1.8-1.4-3 0-1 .8-1.7 1.9-1.7H17a4 4 0 0 0 4-4C21 6.6 17 3 12 3z"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <circle cx="7.5" cy="11.5" r="1.3" fill="currentColor" />
      <circle cx="10.5" cy="7.3" r="1.3" fill="currentColor" />
      <circle cx="15.5" cy="7.6" r="1.3" fill="currentColor" />
    </>
  ),
  // two beamed notes on a staff
  practice: (
    <>
      <path d="M3 5.5h18M3 9h18" strokeWidth="1" opacity="0.5" />
      <path d="M9 18V7.5l10-2V16" />
      <path d="M9 10.5l10-2" strokeWidth="2.6" />
      <ellipse cx="6.6" cy="18" rx="2.9" ry="2.3" fill="currentColor" fillOpacity="0.9" />
      <ellipse cx="16.6" cy="16" rx="2.9" ry="2.3" fill="currentColor" fillOpacity="0.9" />
    </>
  ),
  // a medal on a ribbon
  achievements: (
    <>
      <path d="M8 3h3l1 4.5M16 3h-3l-1 4.5" />
      <circle cx="12" cy="14.5" r="6" fill="currentColor" fillOpacity="0.16" />
      <path d="m12 11 1.1 2.3 2.5.35-1.8 1.75.45 2.5L12 16.7l-2.25 1.2.45-2.5-1.8-1.75 2.5-.35z" fill="currentColor" />
    </>
  ),
  teachers: (
    <>
      <path d="M2 9l10-5 10 5-10 5L2 9z" />
      <path d="M6 11.5V16c0 1.5 3 3 6 3s6-1.5 6-3v-4.5" />
      <path d="M22 9v6" />
    </>
  ),
  settings: (
    <>
      <path d="M4 6h9M17 6h3M4 12h3M11 12h9M4 18h11M19 18h1" />
      <circle cx="15" cy="6" r="2" />
      <circle cx="9" cy="12" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7.5" />,
  // kept for older pages that still import these names
  flashcards: (
    <>
      <rect x="3" y="7" width="14" height="13" rx="2" />
      <path d="M7 7V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2" />
    </>
  ),
  scales: (
    <>
      <path d="M12 3 3 8l9 5 9-5-9-5z" />
      <path d="m3 13 9 5 9-5" />
    </>
  ),
  leaderboard: (
    <>
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
      <path d="M4 22h16" />
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
    </>
  ),
  shop: (
    <>
      <circle cx="8" cy="21" r="1" />
      <circle cx="19" cy="21" r="1" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
    </>
  ),
  upgrades: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 17V8" />
      <path d="m8 12 4-4 4 4" />
    </>
  ),
};

export const Icon = ({ name, className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICON_PATHS[name]}
  </svg>
);